<template>
  <div
    :id="id"
    :ref="id"
    class="flow-part-container"
  >
    <div class="flow-part">
      <div
        class="part-content"
      >
        <slot name="heading" />
        <slot name="content" />
      </div>
      <slot name="slotInfo" />
    </div>
  </div>
</template>
<script>
export default {
    props: {
        id: String,
    },
};
</script>